<template>
	<div class="content-wapper">
		<el-row class="navigation">
		    <el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '' }">知识产权综合服务</el-breadcrumb-item>
					<el-breadcrumb-item>质押融资服务</el-breadcrumb-item>
				</el-breadcrumb>
		    </el-col>
		</el-row>
		<div class="table-div">
			<div class="table-div-title">
				<el-row :gutter="10" class="mb8">
					<el-col>
						<div class="tubiao">
							<!-- <i class="el-icon-s-check"></i> -->
							<span class="tubiao-span">质押融资服务</span>
						</div>
						<div class="tubiao2">
							<span>可申报<font>{{ksbnum}}</font>项</span>
							<!--<span style="margin-left: 20px">可预约<font>{{kyynum}}</font>项</span>-->
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="table-div-contant">
				<el-table v-loading="loading" :data="sxglList" border>
					<el-table-column label="事项名称" align="left" prop="sxmc">
						<template slot-scope="scope">
							<div>
								<span>{{scope.row.sxmc}}</span>
								<span style="color: #409EFF;">[{{scope.row.sxfw}}]</span>
							</div>
							
						</template>
					</el-table-column>
					<el-table-column label="所属部门" align="center"  width="200">知识产权事业发展中心</el-table-column>
					<el-table-column label="截止时间" align="center" prop="jzsj" width="200">
					  <template slot-scope="scope">
					    <span>{{ parseTime(scope.row.jzsj, '{y}-{m}-{d}') }}</span>
					  </template>
					</el-table-column>
					<el-table-column label="所提供服务" align="center" class-name="small-padding fixed-width">
						<template slot-scope="scope">
							<el-button size="small"plain :disabled="scope.row.stgfwBszn === '0'" @click="openPage('/main/zscqzhfw/flfgzc','3')">办事指南</el-button>
							<el-button size="small" plain :disabled="scope.row.stgfwZhengce === '0'"  @click="openPage('/main/zscqzhfw/flfgzc','2')">政策</el-button>
							<el-button size="small" plain :disabled="scope.row.stgfwShenbao === '0'" @click="openShenbao(scope.row)">申报</el-button>
							<!-- <el-button size="small" plain :disabled="scope.row.stgfwYuyue === '0'">预约</el-button> -->
							<el-button size="small" plain :disabled="scope.row.stgfwZixun === '0'" @click="openZxzx()">咨询</el-button>
							<!--<el-button size="small" plain :disabled="scope.row.stgfwShoucang === '0'" @click="onShouChang(scope.row)">收藏</el-button>-->
						</template>
					</el-table-column>
				</el-table>
				<el-pagination class="pagination"
				   @size-change="handleSizeChange"
				   @current-change="handleCurrentChange"
				   :current-page.sync="queryParams.pageNum"
				   :page-size="queryParams.pageSize"
				   :hide-on-single-page="true"
				   :page-sizes="[10, 20, 30, 40]"
				   layout="total, sizes, prev, pager, next, jumper"
				   :total="total"
				   @pagination="getList">
				</el-pagination>	
			</div>
		</div>
	</div>
</template>

<script>
	import {getListDept} from "@/api/system/dept"
	import {addCollect} from "@/api/shoucang/shoucang"
	import {listSxgl,getSxglNum} from "@/api/zscq/sxgl"
	import {updatePvNum} from "@/api/itempv/pv"
	import swal from "sweetalert";
	export default {
		name: "zyrzfw",
		data() {
			return {
				// 遮罩层
				loading: true,
				// 总条数
				total: 0,
				//table列表数据
				sxglList: [],
				// 查询参数
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				//可申报数
				ksbnum: 0,
				//可预约数
				kyynum: 0,
				deptList: [],
				collects:{},
			}
		},
		created() {
			getListDept({}).then(res => {
				this.deptList = res.data || [];
			})
			updatePvNum("zscq_zyrzfw").then(response => {
				//pv 点击知识产权质押融资
			});
			this.getList(this.queryParams);
			this.getnum();
		},
		methods: {
			getList(){
				this.loading = true;
				listSxgl(this.queryParams).then(response => {
				    this.sxglList = response.rows;
				    this.total = response.total;
				    this.loading = false;
				});
			},
			orgcodeFormat(row, column) {
				let name = '';
				for (let dept of this.deptList) {
					if (dept.deptCode === row.orgcode) {
						name = dept.shortName || dept.deptName;
					}
				}
				return name;
			},
			handleSizeChange(val) {
			   // console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
			    //console.log(`当前页: ${val}`);
			    this.getList();
			},
			getnum(){
				getSxglNum({}).then(response => {
				   this.ksbnum = response.data.ksbnum;
				   this.kyynum = response.data.kyynum;
				});
			},
			openShenbao(row){
				//验证是否已经过截止日期
				this.openShenbaoCheckLogin(row);
			},
			onShouChang(row){
				//----【】需要修改为recid
				//收藏
				let ywFwjgRecid=JSON.parse(localStorage.getItem('ssessionLoginUser')).user.ywFwjgRecid;
				if(ywFwjgRecid==null){
					this.msgError("请先登录后，再进行操作！");
					window.location.href="https://zwfw.sd.gov.cn/JIS/front/login.do?uuid=9HOFE5P1Gznq&redirectUrl=https://zhjg.weihai.cn/api/tydlGetTicket";
					return false;
				}else{
					this.getLoginUser(ywFwjgRecid).then(response => {

						//console.log(response);
						//debugger
						if (response.msg == '901') {
							this.msgError("你未登录或登录时限已经超期，请重新登录！");
							window.location.href="https://zwfw.sd.gov.cn/JIS/front/login.do?uuid=9HOFE5P1Gznq&redirectUrl=https://zhjg.weihai.cn/api/tydlGetTicket";
							return false ;
						}else if (response.code == '200') {
							//登录成功
							//先判断是不是黑名单
							//console.log(response.data.isBlackList,"111");
							//判断是否企业，如果是个人，则不能申报
							if(response.data.user.ftype=='1'){
								this.msgError("您不是企业用户，不能办理质押融资申报！");
								return false ;
							}
							else if(response.data.user.isWhEnt=='N'){//判断是否是威海市企业
								this.msgError("你的企业非威海市企业，暂时不能进行此操作！");
								return false ;
							}
							else if(response.data.user.isBlackList=='Y'){
								this.msgError("您的企业属于严重违法失信或异常状态，暂时不能进行此操作！");
								return false ;
							} else if(response.data.user.finishedInfo=='N'){//判断是否已经完善信息
								this.msgError("您的企业信息尚未完善，请前往企业工作室进行基本信息完善操作！");
								// console.log(response.data.user)
								this.$router.push({
									path: '/qygzs/index',
								});
								this.$store.commit('SET_MAININDEX', '/qygzs/index');
								return false ;
							}else{
								//去收藏
								this.collects.busRecid = row.recid;
								this.collects.tableName='yw_zscq_sxgl';
								this.collects.url='/main/zscqzhfw/zyrzfw';
								this.collects.title=row.sxmc+row.sxfw;
								this.collects.ywFwjgRecid=response.data.user.ywFwjgRecid;
										addCollect(this.collects).then(response => {
											this.msgSuccess("收藏成功");
										});
							}
						}

					});
				}

			},
			openShenbaoCheckLogin(row){//验证是否登录
				 
				this.$router.push({
					path: '/main/zscqzhfw/zyrzfwSb',
					query:{sxglRecid:row.recid}
				})
				this.$store.commit('SET_MAININDEX', '/main/zscqzhfw/zyrzfw');
			},
			openPage(pageurl,type2){
				localStorage.setItem("flfg_bussType",JSON.stringify('8'));
				localStorage.setItem("flfg_modeType",JSON.stringify(type2));
				this.utils.windowOpen(pageurl);
			},
			toPage(url){
			    this.$router.push({
			        path: url,
			    });
			    this.$store.commit('SET_MAININDEX', url);
			},
			openZxzx() {

				//----【】需要修改为recid
				//单点登录跳转
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (this.utils.isLoginTimeout()) {
					this.utils.windowOpen("/main/zxzxForm");
				} else {
					if (ssessionLoginUser != null) {
						let ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
						this.$confirm(
								'登录请求已过期，您可以继续留在该页面，或者重新登录?',
								'系统提示', {
									confirmButtonText: '重新登录',
									cancelButtonText: '取消',
									type: 'warning'
								}
						).then(() => {
							this.logout(ywFwjgRecid)
						})
					} else {
						swal( "登录提示", "请登录！","warning",{button: true}).then((value) => {
							// swal(`The returned value is: ${value}`);
							localStorage.clear();
							window.location.href = this.Config.sdtyrzfwLoginUrl;
						});

					}
				}

			},
		}
	}
</script>

<style scoped>
	.content-wapper{
		margin-top: 5px;
		padding: 10px;
	}
	.navigation{
		padding:20px 15px;
		line-height: 20px;
		height: 60px;
		background-color: #F5F5F5;
		margin-bottom: 15px;
	}
	.breadcrumb-div {
		margin-top: 0.6rem;
	}

	.table-div {
		margin-top: 1.3rem;
	}

	.table-div-title {
		width: 100%;
		height: 4.2rem;
		background-color: rgba(230, 230, 230, 0.87);
		line-height: 4.2rem;
	}

	.tubiao {
		float: left;
		font-size: 1.3rem;
		font-weight: bolder;
		margin-left: 1rem;
	}

	.tubiao2 {
		float: right;
		font-size: 1.1rem;
		margin-right: 2rem;
		letter-spacing: 0.1rem;
	}

	.tubiao-span {
		margin-left: 0.5rem;
	}

	font {
		color: #fab21b;
		font-size: 1.4rem;
		margin: 0 0.2rem;
	}
</style>
